var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "aria-label": _vm.ariaLabel,
      "height": _vm.height,
      "width": _vm.width,
      "viewBox": "0 0 75 75",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_108_1109)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M67.0291 1.13184H7.97109C4.19414 1.13184 1.13232 4.19366 1.13232 7.9706V67.0286C1.13232 70.8055 4.19414 73.8673 7.97109 73.8673H67.0291C70.806 73.8673 73.8678 70.8055 73.8678 67.0286V7.9706C73.8678 4.19366 70.806 1.13184 67.0291 1.13184Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.0293 74.9997H7.9938C5.88368 74.9937 3.86178 74.1515 2.37182 72.6573C0.881862 71.1631 0.0454016 69.1388 0.0454102 67.0287V7.94839C0.0454102 5.84035 0.882873 3.81868 2.37348 2.32807C3.86409 0.837463 5.88576 0 7.9938 0H67.0746C69.1847 -8.51512e-06 71.2085 0.836451 72.7027 2.32641C74.1969 3.81637 75.0397 5.83827 75.0457 7.94839V67.142C75.01 69.2423 74.1486 71.2443 72.6485 72.7148C71.1484 74.1852 69.1299 75.006 67.0293 74.9997ZM7.9938 2.26449C6.48818 2.27046 5.04583 2.87113 3.98118 3.93577C2.91654 5.00042 2.31587 6.44277 2.3099 7.94839V67.142C2.30989 68.6515 2.90815 70.0994 3.97344 71.169C5.03873 72.2385 6.48427 72.8426 7.9938 72.8486H67.0746C68.5881 72.8486 70.0392 72.2475 71.1094 71.1773C72.1795 70.1071 72.7812 68.6554 72.7812 67.142V8.06117C72.7752 6.55164 72.1711 5.1061 71.1016 4.04081C70.0321 2.97553 68.5842 2.37726 67.0746 2.37727L7.9938 2.26449Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M42.6856 55.978L61.1865 37.4997L42.6856 19.0215V27.7624H18.3423V47.2371H42.6856V55.978Z",
      "fill": "#FFD100"
    }
  }), _c('path', {
    attrs: {
      "d": "M42.686 57.1111C42.5367 57.1429 42.3825 57.1429 42.2332 57.1111C42.0324 57.0204 41.8615 56.8739 41.7412 56.6893C41.6208 56.5047 41.5558 56.2899 41.5537 56.0696V48.4606H18.3427C18.0424 48.4606 17.7545 48.3412 17.5422 48.1289C17.3298 47.9166 17.2104 47.6287 17.2104 47.3284V27.8535C17.2104 27.5532 17.3298 27.2653 17.5422 27.053C17.7545 26.8406 18.0424 26.7213 18.3427 26.7213H41.5537V19.0902C41.5558 18.8699 41.6208 18.6545 41.7412 18.4699C41.8615 18.2853 42.0324 18.1394 42.2332 18.0486C42.4433 17.9695 42.6709 17.951 42.8911 17.995C43.1113 18.039 43.3147 18.1436 43.4782 18.2974L61.9795 36.7987C62.1818 37.013 62.2941 37.2963 62.2941 37.5909C62.2941 37.8856 62.1818 38.1694 61.9795 38.3837L43.4782 56.8618C43.2563 57.0443 42.9725 57.1339 42.686 57.1111ZM19.4749 46.1055H42.686C42.9863 46.1055 43.2742 46.2248 43.4865 46.4372C43.6989 46.6495 43.8182 46.9374 43.8182 47.2377V53.2389L59.6697 37.3875L43.8182 21.536V27.5594C43.8124 27.8579 43.691 28.1422 43.4799 28.3533C43.2688 28.5644 42.9845 28.6858 42.686 28.6916H19.4749V46.1055Z",
      "fill": "black"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_108_1109"
    }
  }, [_c('rect', {
    attrs: {
      "width": "75",
      "height": "75",
      "fill": "white"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }